function ClearGuestSession(CurrentUserService, LoginService, SessionContext) {
	this._user = CurrentUserService.get();
	this._sessionContext = SessionContext;
	this._logout = LoginService.logout.bind(LoginService);
}

ClearGuestSession.prototype.purge = function () {
	if (this._user.isGuest) {
		this._logout(false /* redirectToHomePage */);
		this._sessionContext.signGuestOut();
	}
};

module.exports = ClearGuestSession;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/clear-guest-session-service.js
 **/